<app-sts-text-captcha 
  #textCaptcha
  *ngIf="captchaType===stsCaptchaType.text" 
  (onValidate)="onSubmit($event)">  
</app-sts-text-captcha>
<app-sts-recaptcha 
  #recaptcha
  *ngIf="captchaType===stsCaptchaType.recaptcha"
  (onValidate)="onSubmit($event)">
</app-sts-recaptcha>
